export const environment = {
  production: true,
  server: '/',
  userKey: 'mcrContabilidade-User'
};



// WEBPACK FOOTER //
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/environments/environment.ts